import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { UpdateImageKindModel } from "../vo/update-image-kind.model";

/**
 * 画像種類同期
 */
@Injectable()
export class UpdateImageKindService extends PlessJsonResponderSub<any> {

  private imageFileList: UpdateImageKindModel[];

  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateImageKindService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        ImageFileList: {
          combination:
            this.imageFileList.map(_ => {
              return {
                condition: {
                  ImageID: _.imageId,
                  ImageUseMethod: _.imageUseMethod,
                  ImageKind: _.imageKind
                }
              }
            })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {UpdateImageKindModel} [imageFileList]
   * @param {Function} [successFunc=null]
   * @memberof UpdateImageKindService
   */
  execute(imageFileList: UpdateImageKindModel[], successFunc: Function): void {
    this.successFunc = successFunc;
    this.imageFileList = imageFileList;
    this.send('KYMW17UpdateImageKind', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateImageKindService
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}
